import { render, staticRenderFns } from "./AddAdminModal.vue?vue&type=template&id=2562029a&scoped=true&"
import script from "./AddAdminModal.vue?vue&type=script&lang=ts&"
export * from "./AddAdminModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddAdminModal.vue?vue&type=style&index=0&id=2562029a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562029a",
  null
  
)

export default component.exports